import React, { useState } from "react";
import ReactDOM from "react-dom";
import Modal, { ModalBody, ModalHeader } from "../../../Components/Modal";
import _axios from "../../../httpService";
import "./ModalUploadPic.scss";
import { toast } from "react-toastify";
import { prefixUrl } from "../../../utils/utilsData";
import profile from "../../../Assets/Images/profile.png";
import utilsFunction from "../../../../src/utils/utilsFunction";
function ModalOverlay(props) {

  const [selectedFile, setSelectedFile] = useState(null);
  const [urlPic, setUrlPic] = useState(props.src);
  const [urlName, setUrlName] = useState('');

  const UploadFileChangeHandler = (event) => {
    
    setSelectedFile(event.target.files[0]);
    const file = event.target.files[0];
    setUrlName(event.target.files[0].name);
    if (!file) {
      setUrlPic("");
      return;
    }

    utilsFunction.fileToDataUri(file).then((dataUri) => {
      setUrlPic(dataUri);
    });
  };

  const submitFileChangeHandler = (event) => {
    event.preventDefault();

    if (!selectedFile) return;

    if (selectedFile.size > 5000000) {
      return toast.warn("سایز فایل باید کمتر از 5 مگابایت باشد");
    }
    
    const formData = new FormData();
    formData.append("image", selectedFile);

    _axios
      .post(prefixUrl() + "/uploadUserPicture/", formData)
      .then((response) => {
        if (response.data.status) {
          toast.success(response.data.message);
          props.setSrc(urlPic);
          setTimeout(() => {
            props.setIsOpen(!props.isOpen);
          },1000);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => toast.error("آپلود فایل با مشکل مواجه شد"));
  };

  return (
    <>
      <Modal
        isOpen={props.isOpen}
        modalCallback={props.modalCallback}
        DarkColorMode={"OFF"}
      >
        <ModalHeader title={" آپلود عکس"} />
        <ModalBody>
          <div className={"d-flex flex-wrap justify-content-center"}>
            <form
              className="uploadPicForm__"
              onSubmit={submitFileChangeHandler}
            >
              <div className="pic_div">
                {urlPic ? (
                  <img src={urlPic} alt="" />
                ) : (
                  <img src={profile} alt="" />
                )}
              </div>
              <label className="fileDesign">
                <input
                  type={"file"}
                  name={"image"}
                  onChange={UploadFileChangeHandler}
                />
                <div className="file-appearance">
                  <div className="append_text"> + تعویض عکس پروفایل</div>
                  { urlName? 
                    <div style={{ fontSize:'12px'}}>{urlName}</div> :
                    <div className={'red__color'} style={{ fontSize:'12px'}}>فایل خود را وارد کنید</div>
                  }
                </div>
              </label>
              <button type="submit">ثبت</button>
            </form>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

const ModalUploadPic = (props) => {
  return (
    <React.Fragment>
      {ReactDOM.createPortal(
        <ModalOverlay {...props} />,
        document.getElementById("overlay-root")
      )}
    </React.Fragment>
  );
};

export default ModalUploadPic;
